import React, { Component } from 'react'
import { Button, Checkbox, Input, Divider, Image } from 'antd';
import { UserOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons';
import './index.css'
import { NavLink, useNavigate} from 'react-router-dom';
//引入axios 进行服务器接口请求
import axios from "axios";

//引入redux--actions
import { setToken,setUserInfo } from '../../redux/actions';
import { store } from '../../redux/store';

export const withNavigation = (Component) => {
  return (props) => <Component {...props} navigate={useNavigate()} />;
};
class Login extends Component {

  state = {
    isChecked: false,
    name: '15311320927',
    password: '111111',
    code: '111111',
    name_isVisible: true,
    password_isVisible: true,
    code_isVisible: true,
    name_msg: '请输入用户名',
    password_msg: '请输入密码',
    code_msg: '请输入验证码',
    captchaSrc: 'https://img2.baidu.com/it/u=2322907879,2593131202&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=1577',
    data: {
      name: '2121212',
      type: 2,
      ids: ['2323', '3232', 'a1111']
    }
  }
  refreshCaptcha = () => {
    this.setState({
      captchaSrc: 'http://img0.baidu.com/it/u=2882487922,1725564666&fm=253&app=138&f=JPEG?w=800&h=1600'
    }); // 刷新验证码，通过添加时间戳来避免缓存问题
  };

  //登录
  login = () => {
    // console.log("lll",this.props.history);
    // this.props.history.push('/home')
    //校验 用户名 密码 验证码 
    let loginValiad = true;
    const { name, password, code } = this.state
    const items = [
      { id: 'name', val: name, msg: '请输入用户名' },
      { id: 'password', val: password, msg: '请输入密码' },
      { id: 'code', val: code, msg: '请输入验证码' }
    ];
    items.map(item => {
      if (!item.val) {
        loginValiad = false;
        return this.setState({
          [item.id + '_isVisible']: false,
          [item.id + '_msg']: item.msg
        })
      }
      return null;
    })
    if (!loginValiad) {
      console.log("dddd11111", loginValiad);
      return
    } else {
      console.log("dddd2222", loginValiad);
      const data = {
        phone: name,
        password,
        code
      }
      //请求后台接口
      this.loginto(data);
    }
  }

  //获取服务器8081接口数据
  loginto = (data) => {
    axios.post('/api/login',
      data, {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    ).then(
      response => {
        if (response.data.code === "200") {
          // this.props.navigate("/main?userdata="+JSON.stringify(response.data.data));
          console.log("dddddd",response.data.data.token);
          // this.props.navigate("/main", { state: response.data.data });
          //  this.props.navigate("/main", { state: response.data.data });
          store.dispatch(setToken(response.data.data.token))
          store.dispatch(setUserInfo(response.data.data))
          // this.props.navigate("/main?zdata="+JSON.stringify(response.data.data));
          this.props.navigate("/main");
        }else{
          this.props.navigate("/error");
        }
      },
      error => {
        console.log('请求8081失败了', error);
        this.props.navigate("/error");
      }
    )
  }

  //输入框赋值
  inputChange = (type, val) => {
    const reg = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
    console.log("11111", reg.test(val));
    if (!reg.test(val)) {
      //输入数据不合理
      this.setState({
        [type + '_isVisible']: false,
        [type + '_msg']: '数据不合规',
        [type]: ''
      })
    } else {
      if (!val) {
        this.setState({
          [type + '_isVisible']: false,
          [type]: ''
        })
      } else {
        this.setState({
          [type + '_isVisible']: true,
          [type]: val
        })
      }
    }
  }
  //记住密码
  rememberPassword = () => {
    const { isChecked } = this.state
    this.setState({
      isChecked: !isChecked, // 切换选中状态
    });
  }


  render() {
    const { captchaSrc, isChecked, name, password, code, name_isVisible, password_isVisible, code_isVisible, name_msg, code_msg, password_msg } = this.state
    return (
      <div className='login_home'>
        <div style={{ height: '12%' }}>
          <div style={{ position: 'fixed', marginLeft: '300px', marginTop: '1.5%', fontSize: '35px' }}>
            对账管理平台LOGO
          </div>
        </div>

        <div className='login-box'>
          <div className='content-div'>
            <div className='login-form'>
              <div className='app-title'>
                登&nbsp;&nbsp;&nbsp;&nbsp;录
              </div>
              <Divider className='divider-style' />
              <div className='item-style'>
                <div className='item-input-style'>
                  <Input value={name} onChange={event => this.inputChange('name', event.target.value)} size="large" placeholder="用户名" prefix={<UserOutlined />} />
                </div>
                <div className='item-span-style'>
                  <span className={name_isVisible ? 'ts-msg-hidden' : 'ts-msg-show'}>{name_msg}</span>
                </div>
                <div className='padding-010'>
                  <Input.Password value={password} onChange={event => this.inputChange('password', event.target.value)} size="large" placeholder="密码" prefix={<LockOutlined />} />
                </div>
                <div className='item-span-style' >
                  <span className={password_isVisible ? 'ts-msg-hidden' : 'ts-msg-show'}>{password_msg}</span>
                </div>
                <div className='item-yzm-style'>
                  <div className='w70'>
                    <Input value={code} size="large" onChange={event => this.inputChange('code', event.target.value)} placeholder="验证码" prefix={<SafetyOutlined />} />
                  </div>
                  <div style={{ paddingLeft: '10px' }}>
                    <Image style={{ cursor: 'pointer' }} preview={false} width='130px' height='38px' src={captchaSrc} alt="captcha" onClick={this.refreshCaptcha} />
                  </div>
                </div>
                <div className='item-span-style'>
                  <span className={code_isVisible ? 'ts-msg-hidden' : 'ts-msg-show'}>{code_msg}</span>
                </div>
                <div className='item-yzm-style'>
                  <Checkbox checked={isChecked} onChange={this.rememberPassword}>记住密码</Checkbox>
                  <NavLink to="/error" className="hover-color-change" style={{ cursor: 'pointer' }} onClick={this.handleClick}>忘记密码</NavLink>
                </div>
                <div className='item-input-style'>
                  <Button type="primary" block size="large" onClick={this.login}>登&nbsp;&nbsp;&nbsp;&nbsp;录</Button>
                </div>
                <div className='item-input-style'>
                  <NavLink to="/register">
                    <Button style={{ border: '1px solid  #1677ff' }} block size="large">注&nbsp;&nbsp;&nbsp;&nbsp;册</Button>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withNavigation(Login);